import React, { useState, useEffect } from "react";
import "../styles/TaskTab.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPlus, faXmark, faHourglassStart } from "@fortawesome/free-solid-svg-icons";
import AddTaskForm from "./AddTaskForm";
import TaskDetails from "./TaskDetails";
import { API_BASE_URL } from '../config';

function TaskTab({ employeeId }) {
  const [showModal, setShowModal] = useState(false);
  const [tasks, setPriorityTasks] = useState([]);
  const [nTasks, setNormalTasks] = useState([]);
  const [subTasksMap, setSubTasksMap] = useState({});
  const [needPhoto, setNeedPhoto] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null); 
  const [selectedTask, setSelectedTask] = useState(null); 

  useEffect(() => {
    
    const fetchTasks = async () => {
      try {
        let savedUser = JSON.parse(localStorage.getItem('user'));
        const response = await fetch(
          `${API_BASE_URL}/api/v1/task/${employeeId}`
          ,{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}}
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const priorityTasks = data.filter((task) => task.priority === true);
        const normalTasks = data.filter((task) => task.priority === false);
        setPriorityTasks(priorityTasks);
        setNormalTasks(normalTasks);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTasks();
  }, [employeeId]);

  useEffect(() => {
    const fetchSubTasks = async () => {
      try {
        const tasksToFetch = [...tasks, ...nTasks];
        const subTasksData = await Promise.all(
          tasksToFetch.map(async (task) => {
            let savedUser = JSON.parse(localStorage.getItem('user'));
            const response = await fetch(
              `${API_BASE_URL}/api/v1/task/sub/${task.id}`,{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}}
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const subTasks = await response.json();
            return { taskId: task.id, subTasks };
          })
        );
        const subTasksMap = {};
        subTasksData.forEach(({ taskId, subTasks }) => {
          subTasksMap[taskId] = subTasks;
        });
        setSubTasksMap(subTasksMap);
      } catch (error) {
        console.error(error);
      }
    };

    if (tasks.length > 0 || nTasks.length > 0) {
      fetchSubTasks();
    }
  }, [tasks, nTasks]);

  const handleDeleteTask = async (taskId) => {
    try {
      let savedUser = JSON.parse(localStorage.getItem('user'));
      const response = await fetch(`${API_BASE_URL}/api/v1/task/${taskId}`, {
        method: "DELETE",
      },{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}});

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const updatedPriorityTasks = tasks.filter((task) => task.id !== taskId);
      const updatedNormalTasks = nTasks.filter((task) => task.id !== taskId);
      setPriorityTasks(updatedPriorityTasks);
      setNormalTasks(updatedNormalTasks);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddSubTask = async (taskId, subTaskName, needPhoto) => {
    try {
      let savedUser = JSON.parse(localStorage.getItem('user'));
      const response = await fetch(`${API_BASE_URL}/api/v1/task/sub`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${savedUser["jwtToken"]}`,
        },
        body: JSON.stringify({
          description: subTaskName,
          needPhoto: needPhoto,
          task: {
            id: taskId,
          },
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();

      const newSubTask = responseData;
      const updatedSubTasksMap = { ...subTasksMap };
      if (updatedSubTasksMap[taskId]) {
        updatedSubTasksMap[taskId].push(newSubTask);
      } else {
        updatedSubTasksMap[taskId] = [newSubTask];
      }
      setSubTasksMap(updatedSubTasksMap);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteSubTask = async (subTaskId, taskId) => {
    try {
      let savedUser = JSON.parse(localStorage.getItem('user'));
      const response = await fetch(
        `${API_BASE_URL}/api/v1/task/sub/${subTaskId}`,
        {
          method: "DELETE",
        },{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}}
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const updatedSubTasksMap = { ...subTasksMap };
      updatedSubTasksMap[taskId] = updatedSubTasksMap[taskId].filter(
        (subTask) => subTask.id !== subTaskId
      );
      setSubTasksMap(updatedSubTasksMap);
    } catch (error) {
      console.error(error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleAddTask = async (newTask) => {
    if (newTask.priority) {
      setPriorityTasks([...tasks, newTask]);
    } else {
      setNormalTasks([...nTasks, newTask]);
    }
  };

  const hasPendingSubTasks = (taskId) => {
    return (
      subTasksMap[taskId] &&
      subTasksMap[taskId].some((subTask) => subTask.done === null)
    );
  };

  const handleTaskClick = async (taskId) => {
    try {
      const task = [...tasks, ...nTasks].find((t) => t.id === taskId);
      if (!task) return;
  
      setSelectedTask(task);
      setSelectedTaskId(taskId);
    } catch (error) {
      console.error("Greška pri otvaranju detalja zadatka:", error);
    }
  };
  

  const currentDate = new Date();
  const todayDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  return (
    <div>
      <div className="header-task">
        <div>
          <button
            className="add-task-button"
            onClick={() => setShowModal(true)}
          >
            <FontAwesomeIcon
              icon={faPlus}
              style={{ fontSize: "1.1em", marginRight: "5px" }}
            />{" "}
            DODAJ ZADATAK
          </button>
        </div>
        {showModal && (
          <div className="modal-overlay">
            <div className="modal">
              <span className="close" onClick={() => setShowModal(false)}>
                {" "}
                &times;{" "}
              </span>
              <AddTaskForm
                employeeId={employeeId}
                closeModal={closeModal}
                onTaskAdded={handleAddTask}
              />
            </div>
          </div>
        )}
      </div>

      <h2 className="priority-title">Prioritetni zadaci</h2>
      <div className="task-list">
        {tasks.map((task, index) => (
          <div
            key={task.id}
            className={`task-list-item`}
            onClick={() => hasPendingSubTasks(task.id) && handleTaskClick(task.id)}
          >
            <div className="task-list-item-header">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center', width:'42%' }}>
                {hasPendingSubTasks(task.id) && (
                  <div className="waiting-icon">
                    <FontAwesomeIcon icon={faHourglassStart} style={{ fontSize: '20px' }}/>
                  </div>
                )}
                <p
                  className={`task-list-item-date ${
                    task.done ? "task-done" : ""
                  }`}
                  style={{
                    color:
                      !task.done && new Date(task.dueDate) < todayDate
                        ? "#c70000"
                        : "",
                    fontWeight:
                      !task.done && new Date(task.dueDate) < todayDate
                        ? "bold"
                        : "normal",
                  }}
                >
                  {new Date(task.dueDate).toLocaleDateString("en-GB")}{" "}
                  {task.dueTime}
                </p>

              </div>
              <button
                className="delete-button"
                onClick={() => handleDeleteTask(task.id)}
              >
                <FontAwesomeIcon
                  icon={faXmark}
                  style={{ color: "#C70000" }}
                  size="2x"
                />
              </button>
            </div>
            <h3 className="task-list-item-title">{task.taskName}</h3>
            <p className="task-list-item-description"> {task.description} </p>
            <div className="sub-tasks-container">
              {subTasksMap[task.id] &&
                subTasksMap[task.id].map((subTask) => (
                  <div
                    id={subTask.id}
                    key={subTask.id}
                    className="sub-task-item"
                  >
                    <p>
                      {subTask.description.length > 100
                        ? `${subTask.description.substring(0, 100)}...`
                        : subTask.description}{" "}
                      {subTask.needPhoto && "(Potrebna slika)"}
                    </p>

                    <button
                      className="delete-subtask-button"
                      onClick={() => handleDeleteSubTask(subTask.id, task.id)}
                    >
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        style={{ color: "#C70000" }}
                      />
                    </button>
                  </div>
                ))}
            </div>
            <div className="add-subtask-form" id={task.id}>
                <div className='div-form'>
                    <label>Naziv:</label>
                    <input type="text" name="subTaskName"/>
                </div>
                <div className='div-form-toggle'>
                    <label>Potrebna slika:</label>
                    <label className="toggle-photo">
                        <input type="checkbox" onChange={(e) => setNeedPhoto(e.target.checked)} />
                        <span className="slider-photo"></span>
                    </label>
                    <button className='add-subtask' type="submit"
                      onClick={(e) => {
                        const inputField = e.target
                          .closest(".add-subtask-form")
                          .querySelector('input[name="subTaskName"]');
                        const subTaskName = inputField.value;
                        handleAddSubTask(task.id, subTaskName, needPhoto);
                        inputField.value = "";
                      }}>
                        <FontAwesomeIcon icon={faPlus} style={{ color: "#2a68db", border: "none" }} size="2x" />
                    </button>
                </div>

            </div>

          </div>
        ))}

    {selectedTaskId && (
      <div className="photo-overlay">
        <div className="modal-photo">
          <span
            className="close-photo"
            onClick={() => setSelectedTaskId(null)}
          >
            &times;
          </span>
          <TaskDetails taskId={selectedTaskId} task={selectedTask} subTasks={subTasksMap[selectedTaskId] || []} />
        </div>
      </div>
    )}

      </div>
      <h2 className="priority-title">Manje prioritetni zadaci</h2>
      <div className="task-list">
        {nTasks.map((task, index) => (
          <div
            key={task.id}
            className={`task-list-item`}
          >
            <div className="task-list-item-header">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center', width:'42%' }}>
                {hasPendingSubTasks(task.id) && (
                  <div className="waiting-icon">
                    <FontAwesomeIcon icon={faHourglassStart} style={{ fontSize: '20px' }}/>
                  </div>
                )}
                <p
                  className={`task-list-item-date ${
                    task.done ? "task-done" : ""
                  }`}
                  style={{
                    color:
                      !task.done && new Date(task.dueDate) < todayDate
                        ? "#c70000"
                        : "",
                    fontWeight:
                      !task.done && new Date(task.dueDate) < todayDate
                        ? "bold"
                        : "normal",
                  }}
                >
                  {new Date(task.dueDate).toLocaleDateString("en-GB")}{" "}
                  {task.dueTime}
                </p>

              </div>
              <button
                className="delete-button"
                onClick={() => handleDeleteTask(task.id)}
              >
                <FontAwesomeIcon
                  icon={faXmark}
                  style={{ color: "#C70000" }}
                  size="2x"
                />
              </button>
            </div>
            <h3 className="task-list-item-title">{task.taskName}</h3>
            <p className="task-list-item-description"> {task.description} </p>
            <div className="sub-tasks-container">
              {subTasksMap[task.id] &&
                subTasksMap[task.id].map((subTask) => (
                  <div key={subTask.id} className="sub-task-item">
                    <p>{subTask.description}</p>
                    <button
                      className="delete-subtask-button"
                      onClick={() => handleDeleteSubTask(subTask.id, task.id)}
                    >
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        style={{ color: "#C70000" }}
                      />
                    </button>
                  </div>
                ))}
            </div>

            <div className="add-subtask-form" id={task.id}>
                <div className='div-form'>
                    <label>Naziv:</label>
                    <input type="text" name="subTaskName"/>
                </div>
                <div className='div-form-toggle'>
                    <label>Potrebna slika:</label>
                    <label className="toggle-photo">
                        <input type="checkbox" onChange={(e) => setNeedPhoto(e.target.checked)} />
                        <span className="slider-photo"></span>
                    </label>
                    <button className='add-subtask' type="submit"
                      onClick={(e) => {
                        const inputField = e.target
                          .closest(".add-subtask-form")
                          .querySelector('input[name="subTaskName"]');
                        const subTaskName = inputField.value;
                        handleAddSubTask(task.id, subTaskName, needPhoto);
                        inputField.value = "";
                      }}>
                        <FontAwesomeIcon icon={faPlus} style={{ color: "#2a68db", border: "none" }} size="2x" />
                    </button>
                </div>

            </div>
          </div>
        ))}

        {selectedTaskId && (
          <div className="photo-overlay">
            <div className="modal-photo">
              <span
                className="close-photo"
                onClick={() => setSelectedTaskId(null)}
              >
                &times;
              </span>
              <TaskDetails taskId={selectedTaskId} task={selectedTask} subTasks={subTasksMap[selectedTaskId] || []} />
            </div>
          </div>
        )}
      </div>
      
    </div>
  );
}

export default TaskTab;
